import { memo, useEffect, useState } from 'react';
import './catalog-photo.css';

// Fit the visible subject, leaving downloaded bitmap bytes untouched.
export default memo(function CatalogPhoto({ item, className = '', frameRatio = 1, loading = 'lazy', alt }) {
  const [failed, setFailed] = useState(false);
  const source = item.imageLocalUrl;
  useEffect(() => setFailed(false), [source]);
  const bounds = item.presentationBounds || item.previewBounds || item.visibleBounds || {
    left: 0, top: 0,
    width: item.previewWidth || item.originalWidth || item.width || 100,
    height: item.previewHeight || item.originalHeight || item.height || 140,
  };
  const sourceWidth = bounds.sourceWidth || item.previewWidth || item.originalWidth || item.width || bounds.width;
  const sourceHeight = bounds.sourceHeight || item.previewHeight || item.originalHeight || item.height || bounds.height;
  const ratio = bounds.width / bounds.height;
  const wide = ratio > frameRatio;
  const objectWidth = wide ? 100 : ratio / frameRatio * 100;
  const objectHeight = wide ? frameRatio / ratio * 100 : 100;

  return <span className={`catalog-photo ${className}`} data-catalog-photo={item.id}
    style={{ width: `calc(var(--catalog-photo-height,80px) * ${frameRatio})`, height: 'var(--catalog-photo-height,80px)' }}>
    {failed ? <span className="catalog-photo-error" role="img" aria-label="素材暂未载入">暂未载入</span> :
      <span className="catalog-photo-object" data-visible-ratio={ratio} style={{ width: objectWidth + '%', height: objectHeight + '%' }}>
        <img src={source} alt={alt || item.name} loading={loading} decoding="async" onError={() => setFailed(true)} style={{
          width: sourceWidth / bounds.width * 100 + '%', height: sourceHeight / bounds.height * 100 + '%',
          left: -(bounds.left ?? bounds.x ?? 0) / bounds.width * 100 + '%', top: -(bounds.top ?? bounds.y ?? 0) / bounds.height * 100 + '%',
          maxWidth: 'none', maxHeight: 'none', margin: 0, objectFit: 'fill', transform: 'none', filter: 'none', borderRadius: 0,
          clipPath: item.presentationClipPolygon ? `polygon(${item.presentationClipPolygon.map(([x, y]) => `${x / sourceWidth * 100}% ${y / sourceHeight * 100}%`).join(',')})` : undefined,
        }}/>
      </span>}
  </span>;
});
